module.exports = __webpack_public_path__ + "img/fullscreen.c162e90a.svg";